export const isWeaveEmail = (email: string | null | undefined): boolean => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const trimmedEmail = email.trim().toLowerCase();
  return trimmedEmail.endsWith('@getweave.com');
};
